import { AlertBox } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';

import styles from './TrueLayerLinkedAccount.module.css';
import { TLinkedBankAccount } from '../trueLayer.helpers';

type TProps = {
  linkedBankAccount?: TLinkedBankAccount[];
};

const TrueLayerLinkedAccount = ({ linkedBankAccount }: TProps) => {
  if (!linkedBankAccount || linkedBankAccount.length === 0) return null;

  return (
    <div className={styles.linkedAccountsContainer}>
      {linkedBankAccount.map((account) => {
        const linkedBankName = account.bank_name;
        const accountNumberMasked = account.account_number_masked;

        return (
          <AlertBox
            key={`${linkedBankName}-${accountNumberMasked}`}
            className={styles.bankAccountStatus}
            variant="connect"
          >
            <img
              className={styles.trueLayerBankLogo}
              src={account.logo_url}
              alt={account.bank_name}
            />
            {accountNumberMasked ? (
              <strong>
                <Trans>
                  Your {linkedBankName} account ending in {accountNumberMasked}{' '}
                  is now linked.
                </Trans>
              </strong>
            ) : (
              <strong>
                <Trans>Your {linkedBankName} account is now linked.</Trans>
              </strong>
            )}
          </AlertBox>
        );
      })}
    </div>
  );
};

export default TrueLayerLinkedAccount;
